module.exports = __webpack_public_path__ + "static/media/15.79de36ce.jpeg";